// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** update House Photos Start ************************/
export const housePhotosUpdate = (updateHousePhotosData: any) => {
	const data = {
		HousePhotosToken: updateHousePhotosData,
	};
	const url = `${API_URL}updateHousePhotos`;
	return makeApiCall(url, data);
};
/** ***************** update House Photos End ************************/
